import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import {
  flexibleFinanceCollage,
  familyLoan,
  happyFamily,
} from "../assets/Images";

// Container for staggered list reveal
const listContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

// Each list item motion
const listItem = {
  hidden: { opacity: 0, x: 40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

// Title + paragraph motion
const textVariant = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

// Image fade-in motion
const imageVariant = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.8 } },
};

const FlexibleFinance = () => {
  return (
    <section className="bg-[#f5f8fc] py-16 px-4 container mx-auto overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Collage image on the left */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={imageVariant}
          className="order-2 md:order-1"
        >
          <img
            src={flexibleFinanceCollage}
            alt="Flexible Finance"
            className="rounded-2xl w-full object-cover hover:scale-[1.02] transition-transform duration-500"
          />
        </motion.div>

        {/* Text + List on the right */}
        <div className="flex flex-col gap-6 order-1 md:order-2 xl:space-y-8">
          {/* Heading & paragraph */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={textVariant}
          >
            <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 xl:mb-12">
              Flexible Finance For <br /> Added Shine
            </h3>
            <p className="text-gray-600 leading-relaxed">
              At Subramaniam Financial Services, we believe financial help should never be hard. That’s why our loans are flexible, easy to apply for, and designed to support your dreams  big or small.
              (Let your plans shine. We’ll take care of the rest).
            </p>
          </motion.div>

          {/* Animated list */}
          <motion.ul
            className="space-y-4 md:space-y-2 lg:space-y-4"
            variants={listContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ repeat: true }}
          >
            {[
              "Your one-stop destination for all financial needs.",
              "No hidden charges and a dedicated loan expert.",
              "Dedicated loan experts for every customer.",
            ].map((text, index) => (
              <motion.li
                key={index}
                variants={listItem}
                className="flex items-start gap-3"
              >
                <FaCheckCircle className="text-green-600 text-lg flex-shrink-0 mt-1" />
                <span className="text-gray-700">{text}</span>
              </motion.li>
            ))}
          </motion.ul>
        </div>
      </div>

      {/* Bottom 2 images in separate row */}
      <div className="max-w-7xl mx-auto mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        {[familyLoan, happyFamily].map((imgSrc, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            className="overflow-hidden rounded-2xl"
          >
            <img
              src={imgSrc}
              alt={`Bottom ${index + 1}`}
              className="w-full object-cover rounded-2xl shadow-lg hover:scale-105 transition-transform duration-500"
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default FlexibleFinance;
